import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "evses" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "first-column-with-icon-type" }
const _hoisted_6 = { class: "name-type-block" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "emq-table-footer" }

import { delEvse, banEvse, listEvse } from '@/api/evses'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import EvseDrawer from './components/EvseDrawer.vue'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import PermissionLink from '@/components/PermissionLink.vue'

import {
  ArrowDown,
  ArrowUp,
  Refresh,
  RefreshLeft,
  Search,
  Plus,
  Download,
} from '@element-plus/icons-vue'
import { pick } from 'lodash'
import IconLightning from '@/components/IconLightning.vue'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import SelectOperator from '@/components/SelectOperator.vue'
import SelectStation from '@/components/SelectStation.vue'
import EvseStatusSimple from '@/components/EvseStatusSimple.vue'
import { checkMenuShow } from '@/store/tool'
import { dateFormat, throttleBtn } from '@/common/tools'
import { EvseState } from '@/types/types'
import { ElMessage, ElMessageBox } from 'element-plus'
import LinkOperator from '@/components/Links/LinkOperator.vue'
import LinkStation from '@/components/Links/LinkStation.vue'
import LinkEvse from '@/components/Links/LinkEvse.vue'


import { defineComponent, ref, computed, defineProps, reactive, nextTick } from 'vue'
import EvseDownLoadSelectTypeDialog from './components/EvseDownLoadSelectTypeDialog.vue'
const __default__ = defineComponent({
  name: 'Evses',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  opeartorID: {
    type: String,
    default: '',
  },
  stationID: {
    type: String,
    default: '',
  },
  showDownloadBtn: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const EvseDrawerRef = ref()

const { t } = useI18nTl('Evses')

const showDownloadCodeTypeDialog = ref(false)
const selectDownloadList = ref([])
const showDialog = ref(false)
const editEditFlag = ref(false)
const showDialogEvse = ref({})
const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({
  state: EvseState.ES_ONLINE,
})
const { enableSelects, evseStateSelects } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')


const isStation = computed(function () {
  return props.stationID != '' && props.stationID != '0'
})

const addEvse = () => {
  editEditFlag.value = false
  showDialogEvse.value = {}
  showDialog.value = true
  EvseDrawerRef.value?.clearValidate()
}
const editEvse = (row: any) => {
  showDialogEvse.value = row
  editEditFlag.value = true
  showDialog.value = true
}

const deleteEvse = async (row: any) => {
  await ElMessageBox.confirm(t('Evses.deleteEvseConfirm'), {
    confirmButtonText: t('Base.confirm'),
    cancelButtonText: t('Base.cancel'),
    confirmButtonClass: 'confirm-danger',
    type: 'warning',
  })

  try {
    await delEvse(row.id)
    ElMessage.success(t(`Base.opSuccess`))
    loadEvses()
  } catch (error) {
    console.error('del error:', error)
  }
}

const handleSearch = async () => {
  console.log('fuzzyParams', fuzzyParams.value)
  params.value = genQueryParams(fuzzyParams.value)
  loadEvses({ page: 1 })
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const downloadQrCode = async () => {
  const selectStationList = TableCom.value?.getSelectionRows() || []

  selectDownloadList.value = selectStationList

  showDownloadCodeTypeDialog.value = true
}
const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const {
    id,
    sn,
    enable,
    firewareVersion,
    state,
    beginTime,
    endTime,
    operatorId,
    stationId,
    isOperation,
  } = params
  newParams = {
    id: id || undefined,
    sn: sn || undefined,
    enable: enable || undefined,
    firewareVersion: firewareVersion || undefined,
    state: state || undefined,
    beginTime: beginTime || undefined,
    endTime: endTime || undefined,
    operatorId: operatorId || 0,
    stationId: stationId || '',
    isOperation: isOperation || undefined,
  }
  return newParams
}
const handleSwitchStatus = async (row: any) => {
  // banEvse(row.id, !row.banned)
  try {
    await banEvse(row.id, row.banned)
    if (!row.banned) {
      ElMessage.success(t('Base.disabledSuccess'))
    } else {
      ElMessage.success(t('Base.enableSuccess'))
    }
    await loadEvses()
  } catch (error) {
    console.error(error)
    // row.enable = !row.enable
  }
}

const loadEvses = async (_params = {}) => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
  }
  if (!sendParams.stationId || sendParams.stationId == '') {
    if (props.stationID != '') {
      sendParams.stationId = props.stationID
    } else {
      sendParams.stationId = '0'
    }
  }
  sendParams.state = fuzzyParams.value.state

  try {
    const { list = [], pageReply = {} } = await listEvse(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = []
    tableData.value = list.map((item: any) => ({
      ...item,
      showEnable: !item.banned,
    }))
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadEvses)
loadEvses()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isStation))
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          class: "search-wrapper",
          onKeyup: _withKeys(handleSearch, ["enter"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: fuzzyParams.value.sn,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.sn) = $event)),
                      placeholder: _ctx.$t('Evses.sn'),
                      clearable: "",
                      onClear: handleSearch
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: fuzzyParams.value.enable,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.enable) = $event)),
                      placeholder: _ctx.$t('Base.isEnabled'),
                      clearable: "",
                      onClear: handleSearch
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(enableSelects), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.value,
                            key: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(SelectOperator, {
                      modelValue: fuzzyParams.value.operatorId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.operatorId) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 16),
                (showMoreQuery.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                        default: _withCtx(() => [
                          _createVNode(SelectStation, {
                            modelValue: fuzzyParams.value.stationId,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fuzzyParams.value.stationId) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 16),
                      _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: fuzzyParams.value.firewareVersion,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((fuzzyParams.value.firewareVersion) = $event)),
                            placeholder: _ctx.$t('Evses.firmwareVersion'),
                            clearable: "",
                            onClear: handleSearch
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 16),
                      _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: fuzzyParams.value.id,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((fuzzyParams.value.id) = $event)),
                            placeholder: _ctx.$t('Evses.id'),
                            clearable: "",
                            onClear: handleSearch
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 16)
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      plain: "",
                      icon: _unref(Search),
                      onClick: handleSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_button, {
                      icon: _unref(RefreshLeft),
                      onClick: handleReset
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_tooltip, {
                      content: !showMoreQuery.value ? _ctx.$t('Base.showMore') : _ctx.$t('Base.lessMore'),
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "icon-button",
                          plain: "",
                          icon: showMoreQuery.value ? _unref(ArrowUp) : _unref(ArrowDown),
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (showMoreQuery.value = !showMoreQuery.value))
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["content"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onKeyup"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_radio_group, {
          class: "legend-select",
          modelValue: fuzzyParams.value.state,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((fuzzyParams.value.state) = $event)),
          onChange: handleSearch,
          disabled: lockTable.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, {
              label: _unref(EvseState).ES_ONLINE
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Evses.stateOnline')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio_button, {
              label: _unref(EvseState).ES_OFFLINE
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Evses.stateOffline')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio_button, {
              label: _unref(EvseState).ES_EXCEPTION
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Evses.stateException')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio_button, {
              label: _unref(EvseState).ES_NONACTIVATED
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Evses.stateNonactivated')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio_button, {
              label: _unref(EvseState).EC_UNKNOWN
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Base.all')), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (addEvse()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'evseUpsert']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"]),
        (__props.showDownloadBtn)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              icon: _unref(Download),
              onClick: downloadQrCode
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Operation.downloadQrCode')), 1)
              ]),
              _: 1
            }, 8, ["icon"]))
          : _createCommentVNode("", true)
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "evseSn"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "sn",
            "min-width": "80",
            label: _ctx.$t('Evses.sn'),
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkEvse, {
                id: row.id,
                name: row.sn
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            label: _ctx.$t('Evses.operatorName')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(LinkOperator, {
                    id: row.operatorID,
                    name: row.operatorName
                  }, null, 8, ["id", "name"]),
                  _hoisted_7,
                  _createVNode(LinkStation, {
                    id: row.stationID,
                    name: row.stationName ? row.stationName : '-'
                  }, null, 8, ["id", "name"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "state",
            "min-width": "80",
            label: _ctx.$t('Evses.state')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(EvseStatusSimple, {
                state: row.state
              }, null, 8, ["state"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "connector",
            "min-width": "80",
            label: _ctx.$t('Evses.connector')
          }, {
            default: _withCtx(({ row }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.connector, (item, index) => {
                return (_openBlock(), _createBlock(IconLightning, {
                  state: item.state,
                  cno: item.connectorNo,
                  key: index
                }, null, 8, ["state", "cno"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "firmwareVersion",
            "min-width": "100",
            label: _ctx.$t('Evses.firmwareVersion')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "showEnable",
            label: _ctx.$t('Base.enable')
          }, {
            default: _withCtx(({ row }) => [
              (row.isOperating)
                ? (_openBlock(), _createBlock(_component_el_switch, {
                    key: 0,
                    modelValue: row.banned,
                    "onUpdate:modelValue": ($event: any) => ((row.banned) = $event),
                    onChange: ($event: any) => (handleSwitchStatus(row)),
                    "active-value": false,
                    "inactive-value": true,
                    disabled: !_unref(checkMenuShow)('evseBan')
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)('Evses.nonOperational')), 1))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "power",
            "min-width": "50",
            label: _ctx.$t('Evses.power')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.evseModel.ratedPower / 1000) + " KW ", 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "createdAt",
            "min-width": "100",
            label: _ctx.$t('Base.regtime')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(PermissionLink, {
                to: {
                name: 'evse-detail',
                params: { id: row.id },
              },
                role: ['evseInfo']
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Base.view')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["to"]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (editEvse(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'evseUpsert']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (deleteEvse(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.delete')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'evseUpsert']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[9] || (_cache[9] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          pageSizeOpt: [10, 20, 50, 100],
          onLoadPage: loadEvses
        }, null, 8, ["metaData"])
      ]),
      _createVNode(EvseDrawer, {
        ref_key: "EvseDrawerRef",
        ref: EvseDrawerRef,
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showDialog).value = $event)),
        opeartorID: props.opeartorID,
        stationID: props.stationID,
        isEdit: editEditFlag.value,
        evseInfo: showDialogEvse.value,
        onSubmitted: loadEvses
      }, null, 8, ["modelValue", "opeartorID", "stationID", "isEdit", "evseInfo"]),
      _createVNode(EvseDownLoadSelectTypeDialog, {
        modelValue: showDownloadCodeTypeDialog.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((showDownloadCodeTypeDialog).value = $event)),
        stationId: props.stationID,
        selectDownloadList: selectDownloadList.value
      }, null, 8, ["modelValue", "stationId", "selectDownloadList"])
    ])
  ]))
}
}

})